<template>
    <v-modal-slot id="edit-statuses-modal"
                  @accepted="editStatus">
        <template v-slot:modal-title>
            Editar información del estado
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <strong class="form-label">Nombre: </strong>
                    <span>{{ status.display_name }}</span>
                </div>
            </div>

            <div class="row">
                <div class="form-group">
                    <label>Observaciones:</label>
                    <textarea class="form-control" v-model="status.extra_data"></textarea>
                </div>

                <div class="form-group col-6">
                    <label>Fecha:</label>

                    <div class="input-group">
                        <template v-if="can('status.use.' + status.name)">
                            <input type="datetime-local" class="form-control" v-model="status.date"/>
                            <button class="delete-date" @click="status.date = ''" :disabled="!status.date ? true : null">
                                <span class="uq-icon bi-x-lg"></span>
                            </button>
                        </template>

                        <span v-else>{{ status.date ? dateToReadable(status.date) : 'Sin fecha' }}</span>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>
</template>

<script>
import VModal from "../../general/VModal";
import {editExpedientStatus} from "../../../helpers/requests/RequestsStatuses";
import VModalSlot from "../../general/VModalSlot";
import {can} from "../../../helpers/Permissions";
import {downloadAttorneysXLSX} from "../../../helpers/Exports";

export default {
    name: "StatusesListEditModal",
    components: {VModalSlot, VModal},
    props: {
        status: {
            type: Object,
            required: true,
        },
        expedient: {
            type: Object,
            required: true,
        }
    },
    setup() {
        return {
            can,
        }
    },
    data() {
        return {
            statusApp: 'loading',
            modal: null,
            errors: [],
        }
    },
    mounted() {
        // FIXME Cosa rara de Dani
        // TODO: This must be set using Carbon (a readable-format date). Thx.

        // We need to format the date to be accepted by the input
        if (!!this.status.date) {
            // The date we receive: 2021-06-24 18:38:00
            let datetime = this.status.date.split(' ');
            let date = datetime[0].split('-');
            let year = date[0];
            let month = date[1];
            let day = date[2];
            let time = datetime[1].split(':');
            let hour = time[0];
            let minute = time[1];
            // The date we need: 2018-06-12T19:30
            this.status.date = year + '-' + month + '-' + day + 'T' + hour + ':' + minute;
        }
    },
    methods: {
        dateToReadable(date) {
            let splitted = date.substr(0, 10).split('-');
            return splitted[2] + '/' + splitted[1] + '/' + splitted[0];
        },
        async editStatus() {
            try {
                await editExpedientStatus(this.expedient, this.status);

                this.$store.dispatch('app/setToastMessage', 'Cambios guardados con éxito');
                this.$emit('expedient-status-edited');

                this.closeModal();

            } catch (e) {
                this.$store.dispatch('app/setErrorToastMessage', 'Error al guardar los cambios');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
